export const feeds = [
  {
    cat: "tagesschau",
    navName: "Tagesschau",
    rssUrl: "https://www.tagesschau.de/xml/rss2"
  },
  {
    cat: "zdfheute",
    navName: "ZDFheute",
    rssUrl: "https://www.zdf.de/rss/zdf/nachrichten"
  },
  {
    cat: "zeit",
    navName: "Zeit Online",
    rssUrl: "http://newsfeed.zeit.de/all"
  },
  {
    cat: "sz-top",
    navName: "Süddeutsche Zeitung",
    rssUrl: "https://rss.sueddeutsche.de/rss/Topthemen"
  },
  {
    cat: "spiegel",
    navName: "Spiegel",
    rssUrl: "https://www.spiegel.de/schlagzeilen/index.rss"
  },
  {
    cat: "focus",
    navName: "Focus Online",
    rssUrl: "https://rss.focus.de/fol/XML/rss_folnews.xml"
  },
  {
    cat: "diewelt",
    navName: "Die Welt",
    rssUrl: "https://www.welt.de/feeds/latest.rss"
  },
  {
    cat: "faz",
    navName: "FAZ",
    rssUrl: "https://www.faz.net/rss/aktuell/"
  },
  {
    cat: "stern",
    navName: "Stern",
    rssUrl: "https://www.stern.de/feed/standard/all/"
  },
  {
    cat: "bild",
    navName: "Bild",
    rssUrl: "https://www.bild.de/rss-feeds/rss-16725492,feed=home.bild.html"
  },
  {
    cat: "dw",
    navName: "Deutsche Welle",
    rssUrl: "https://rss.dw.com/xml/rss-de-all"
  },
  {
    cat: "nachdenkseiten",
    navName: "NachDenkSeiten",
    rssUrl: "https://www.nachdenkseiten.de/?feed=rss2"
  },
  {
    cat: "derstandard",
    navName: "Der Standard",
    rssUrl: "https://www.derstandard.at/rss"
  },
  {
    cat: "wiwo",
    navName: "Wirtschaftswoche",
    rssUrl: "https://www.wiwo.de/contentexport/feed/rss/schlagzeilen"
  },
  {
    cat: "dlf",
    navName: "Deutschlandfunk",
    rssUrl: "https://www.deutschlandfunk.de/die-nachrichten.353.de.rss"
  },
  {
    cat: "br24",
    navName: "BR24",
    rssUrl: "https://nachrichtenfeeds.br.de/rdf/boards/QXAPkQJ"
  }
];
